import React from 'react';
import { CircularProgress } from "@mui/material";

function CircularLoadingScreen({containerStyles, ...rest}) {
    return (
        <div className="loading-screen" style={{
            height: '100%',
            width: '100%',
            backgroundColor: 'white',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ...containerStyles
        }}>
           <CircularProgress {...rest}/> 
        </div>
    );
}

export default CircularLoadingScreen